var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vdp-axis",style:({
        'height': this.computedHeight + 'px', 
        'width': this.computedWidth + 'px',
        'top': this.computedTop + 'px',
        'left': this.computedLeft + 'px'
    }),attrs:{"id":this.axisElemID}})}
var staticRenderFns = []

export { render, staticRenderFns }